import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { SEQUENCES_LIST_KEY } from 'queries/sequences/useSequencesFolders';
import { useTranslation } from 'react-i18next';

function deleteFolder({ folderId }: { folderId: string }) {
  const requestURL = `/folders/${folderId}`;
  return request(requestURL, {
    method: 'DELETE',
  });
}

export function useDeleteFolder() {
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['sequence']);
  const { mutateAsync } = useMutation({
    mutationFn: ({ folderId }: { folderId: string }) =>
      deleteFolder({ folderId }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('sequence:messages.folder.deleteError'),
      });
    },
  });
  return mutateAsync;
}
